import*as e from"react";const r=e.createContext({status:{loading:!0,error:void 0},company:{id:"",name:""},sub:"",email_verified:"",given_name:"",family_name:"",email:"",username:"",companyName:"",userpoolID:"",role:""});export{r as UserContext};
//# sourceMappingURL=user.js.map
